
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.592 2.5c0-.335.271-.606.606-.606h15.6a.606.606 0 110 1.212h-15.6a.606.606 0 01-.606-.606zM5.99 6.252c0-.335.272-.607.607-.607h6.825a.606.606 0 110 1.213H6.597a.606.606 0 01-.607-.606zM.395 10c0-.335.271-.606.606-.606h18a.606.606 0 110 1.212H1A.606.606 0 01.395 10zm5.295 3.751c0-.335.27-.606.606-.606h7.425a.606.606 0 010 1.213H6.296a.606.606 0 01-.607-.607zM1.592 17.5c0-.335.271-.606.606-.606h15.6a.606.606 0 110 1.212h-15.6a.606.606 0 01-.606-.606z","fill":"#666"}})])
          )
        }
      }
    